/* FELRIO — Watch & Shop Row: autoplay muted video previews in the home strip */
(function () {
  'use strict';

  function initRow(section) {
    if (section.dataset.felrioWsrInit === '1') return;
    section.dataset.felrioWsrInit = '1';

    var videos = section.querySelectorAll('.felrio-wsr__grid video.felrio-wsr__video');
    if (!videos.length) return;

    videos.forEach(function (video) {
      video.muted = true;
      video.loop = true;
      video.playsInline = true;
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
    });

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            var v = entry.target;
            if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
              v.muted = true;
              v.play().catch(function () {});
            } else {
              try { v.pause(); } catch (e) {}
            }
          });
        },
        { threshold: [0, 0.5, 0.9] }
      );
      videos.forEach(function (v) { io.observe(v); });
    } else {
      videos.forEach(function (v) { v.play().catch(function () {}); });
    }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        videos.forEach(function (v) { try { v.pause(); } catch (e) {} });
      }
    });
  }

  function initAll() {
    document.querySelectorAll('[data-felrio-wsr]').forEach(initRow);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('[data-felrio-wsr]');
    if (section) initRow(section);
  });
})();
